import { render, staticRenderFns } from "./BlockUserNotes.vue?vue&type=template&id=23ca0940&"
import script from "./BlockUserNotes.vue?vue&type=script&lang=ts&"
export * from "./BlockUserNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports